<template>
  <div v-if="content">
    <el-row :gutter="10">
      <el-col :span="8" class="center">
        {{ label }}
      </el-col>
      <el-col :span="12">
        <div
          class="allow-click-copy"
          @click="doCopy(content)"
        >
          {{ content }}
        </div>
      </el-col>
      <el-col :span="4">
        <el-tooltip
          v-if="hasFilter"
          class="item"
          effect="dark"
          placement="bottom"
          :open-delay="500"
          :content="$t('api.actions.itemLink.search')"
        >
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-search"
            circle
            @click="filter"
          >
          </el-button>
        </el-tooltip>
      </el-col>
    </el-row>
    <el-divider></el-divider>
  </div>
</template>

<script>

import { doCopy } from '@/utils/copy'

export default {
  name: 'pop-row',
  props: {
    label: {
      type: String,
      default: ''
    },
    content: {
      type: [String, Number],
      default: ''
    },
    hasFilter: {
      type: Boolean,
      default: true
    },
    filter: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    doCopy
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.el-button--mini.is-circle {
  padding: 5px;
}
.el-col.center {
  text-align: center;
}
.el-divider {
  margin: 10px 0;
}
</style>
